import { getVideoLimitDetail } from './getAssetDropToastMessage';
import { VIDEO_TO_GIF_MAX_DURATION_SECONDS } from './videoToGifLimits';

/** Undefined duration is not a block. Some video nodes never store it. */
export const getVideoToGifDisabledReason = (duration: number | undefined): string | undefined => {
  if (duration === undefined || duration <= VIDEO_TO_GIF_MAX_DURATION_SECONDS) {
    return undefined;
  }

  return `Video ${getVideoLimitDetail(['duration'])}`;
};
